export const urlDomain = 'http://loftyapps.com';

export const urlPlatformDomain = 'http://platform.loftyapps.com';
